module.exports = __webpack_public_path__ + "static/media/mappie-logo-light.90c4f6c7.svg";